const state = {
  activateVoucher: '', // 验证注册验证码后返回的激活凭证
  authenticationInfo: {}, // 创建机构的第一步所填基本信息
  proTitleId: null, // 申请个人认证第一步所选认证类型
  organizationMessage: {}, // 选择的机构信息
  tissueMessage: {}, // 选择的组织信息
  organizationCheckedInfo: {}, // 机构认证信息

  menuIndex: '',
  organizations: [], // 登录机构信息
  resources: [], // 权限列表
  logoUrl: '', // 医院logo
  organizationName: '', // 机构名称
  itemType: [] // 体检项目类别列表
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js